import { RIDE_DETAILS_BREAKDOWN_NO_POST_INCIDENT_MOCK } from './rideDetailsBreakdownNoPostIncidentRaw';
import { RIDE_DETAILS_BREAKDOWN_MOCK } from './rideDetailsBreakdownRaw';
import { RIDE_DETAILS_OPERATIONAL_STOP_MOCK } from './rideRegularWithOperationalStopRaw';

// Ordered registry of mock ride payloads. The `id` is what
// `RideDetailsStore.useMockData` stores — the toggle component renders
// one checkbox per entry, grouped by `group`, only one is active at a time.
export const RIDE_DETAILS_MOCKS = [
	{
		id: 'regular-with-operational-stop',
		group: 'Regular options',
		label: '3 stations, middle one is operational',
		payload: RIDE_DETAILS_OPERATIONAL_STOP_MOCK,
	},
	{
		id: 'breakdown-mid-route',
		group: 'Breakdown data',
		label: 'Mid-route breakdown (with post-incident driving)',
		payload: RIDE_DETAILS_BREAKDOWN_MOCK,
	},
	{
		id: 'breakdown-no-post-incident',
		group: 'Breakdown data',
		label: 'Breakdown at tail (no post-incident driving)',
		payload: RIDE_DETAILS_BREAKDOWN_NO_POST_INCIDENT_MOCK,
	},
];

export const findRideDetailsMockById = (mockId) =>
	RIDE_DETAILS_MOCKS.find((mock) => mock.id === mockId) ?? null;
